/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingRewardLedgerComponent } from './BookingRewardLedgerComponent';
import {
    BookingRewardLedgerComponentFromJSON,
    BookingRewardLedgerComponentFromJSONTyped,
    BookingRewardLedgerComponentToJSON,
    BookingRewardLedgerComponentToJSONTyped,
} from './BookingRewardLedgerComponent';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 *
 * @export
 * @interface BookingRewardAuditItem
 */
export interface BookingRewardAuditItem {
    /**
     *
     * @type {string}
     * @memberof BookingRewardAuditItem
     */
    bookingType: BookingRewardAuditItemBookingTypeEnum;
    /**
     *
     * @type {number}
     * @memberof BookingRewardAuditItem
     */
    bookingId: number;
    /**
     *
     * @type {boolean}
     * @memberof BookingRewardAuditItem
     */
    ownerMatchesRequest: boolean;
    /**
     *
     * @type {string}
     * @memberof BookingRewardAuditItem
     */
    applicationStatus?: BookingRewardAuditItemApplicationStatusEnum | null;
    /**
     *
     * @type {string}
     * @memberof BookingRewardAuditItem
     */
    applicationFingerprint?: string | null;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof BookingRewardAuditItem
     */
    applicationResponse?: { [key: string]: any; } | null;
    /**
     *
     * @type {Array<BookingRewardLedgerComponent>}
     * @memberof BookingRewardAuditItem
     */
    ledgerComponents: Array<BookingRewardLedgerComponent>;
    /**
     *
     * @type {number}
     * @memberof BookingRewardAuditItem
     */
    activeLedgerCount: number;
    /**
     *
     * @type {string}
     * @memberof BookingRewardAuditItem
     */
    debitState: BookingRewardAuditItemDebitStateEnum;
    /**
     *
     * @type {number}
     * @memberof BookingRewardAuditItem
     */
    debitCount: number;
    /**
     *
     * @type {number}
     * @memberof BookingRewardAuditItem
     */
    debitAmount?: number | null;
    /**
     *
     * @type {string}
     * @memberof BookingRewardAuditItem
     */
    debitCurrency?: string | null;
    /**
     *
     * @type {Array<CurrencyAmount>}
     * @memberof BookingRewardAuditItem
     */
    availableBalances: Array<CurrencyAmount>;
    /**
     *
     * @type {string}
     * @memberof BookingRewardAuditItem
     */
    auditDigest: string;
}


/**
 * @export
 */
export const BookingRewardAuditItemBookingTypeEnum = {
    Hotel: 'hotel',
    Vehicle: 'vehicle'
} as const;
export type BookingRewardAuditItemBookingTypeEnum = typeof BookingRewardAuditItemBookingTypeEnum[keyof typeof BookingRewardAuditItemBookingTypeEnum];

/**
 * @export
 */
export const BookingRewardAuditItemApplicationStatusEnum = {
    Processing: 'processing',
    Succeeded: 'succeeded',
    Cancelled: 'cancelled'
} as const;
export type BookingRewardAuditItemApplicationStatusEnum = typeof BookingRewardAuditItemApplicationStatusEnum[keyof typeof BookingRewardAuditItemApplicationStatusEnum];

/**
 * @export
 */
export const BookingRewardAuditItemDebitStateEnum = {
    Missing: 'missing',
    Zero: 'zero',
    Nonzero: 'nonzero',
    Multiple: 'multiple'
} as const;
export type BookingRewardAuditItemDebitStateEnum = typeof BookingRewardAuditItemDebitStateEnum[keyof typeof BookingRewardAuditItemDebitStateEnum];


/**
 * Check if a given object implements the BookingRewardAuditItem interface.
 */
export function instanceOfBookingRewardAuditItem(value: object): value is BookingRewardAuditItem {
    if (!('bookingType' in value) || value['bookingType'] === undefined) return false;
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    if (!('ownerMatchesRequest' in value) || value['ownerMatchesRequest'] === undefined) return false;
    if (!('ledgerComponents' in value) || value['ledgerComponents'] === undefined) return false;
    if (!('activeLedgerCount' in value) || value['activeLedgerCount'] === undefined) return false;
    if (!('debitState' in value) || value['debitState'] === undefined) return false;
    if (!('debitCount' in value) || value['debitCount'] === undefined) return false;
    if (!('availableBalances' in value) || value['availableBalances'] === undefined) return false;
    if (!('auditDigest' in value) || value['auditDigest'] === undefined) return false;
    return true;
}

export function BookingRewardAuditItemFromJSON(json: any): BookingRewardAuditItem {
    return BookingRewardAuditItemFromJSONTyped(json, false);
}

export function BookingRewardAuditItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingRewardAuditItem {
    if (json == null) {
        return json;
    }
    return {

        'bookingType': json['booking_type'],
        'bookingId': json['booking_id'],
        'ownerMatchesRequest': json['owner_matches_request'],
        'applicationStatus': json['application_status'] == null ? undefined : json['application_status'],
        'applicationFingerprint': json['application_fingerprint'] == null ? undefined : json['application_fingerprint'],
        'applicationResponse': json['application_response'] == null ? undefined : json['application_response'],
        'ledgerComponents': ((json['ledger_components'] as Array<any>).map(BookingRewardLedgerComponentFromJSON)),
        'activeLedgerCount': json['active_ledger_count'],
        'debitState': json['debit_state'],
        'debitCount': json['debit_count'],
        'debitAmount': json['debit_amount'] == null ? undefined : json['debit_amount'],
        'debitCurrency': json['debit_currency'] == null ? undefined : json['debit_currency'],
        'availableBalances': ((json['available_balances'] as Array<any>).map(CurrencyAmountFromJSON)),
        'auditDigest': json['audit_digest'],
    };
}

export function BookingRewardAuditItemToJSON(json: any): BookingRewardAuditItem {
    return BookingRewardAuditItemToJSONTyped(json, false);
}

export function BookingRewardAuditItemToJSONTyped(value?: BookingRewardAuditItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'booking_type': value['bookingType'],
        'booking_id': value['bookingId'],
        'owner_matches_request': value['ownerMatchesRequest'],
        'application_status': value['applicationStatus'],
        'application_fingerprint': value['applicationFingerprint'],
        'application_response': value['applicationResponse'],
        'ledger_components': ((value['ledgerComponents'] as Array<any>).map(BookingRewardLedgerComponentToJSON)),
        'active_ledger_count': value['activeLedgerCount'],
        'debit_state': value['debitState'],
        'debit_count': value['debitCount'],
        'debit_amount': value['debitAmount'],
        'debit_currency': value['debitCurrency'],
        'available_balances': ((value['availableBalances'] as Array<any>).map(CurrencyAmountToJSON)),
        'audit_digest': value['auditDigest'],
    };
}

